import React, {useEffect} from 'react';
import { PDFDocument } from 'pdf-lib';
// import fontkit from '@pdf-lib/fontkit';
import pdfCompleto from '../assets/pdf/pdf-completo.pdf';

const Pdf = () => {

  useEffect(() => {
    readPdf()
  }, []);

  const readPdf = async () => {
    const fromBytes = await fetch(pdfCompleto).then((res) => res.arrayBuffer());
    console.log(fromBytes)

    // Load the PDF with form fields
    const pdfDoc = await PDFDocument.load(fromBytes);

    console.log(pdfDoc)

    const form = pdfDoc.getForm();
    console.log(form)
    const field1 = form.getTextField('Text1');
    const field2 = form.getTextField('Text2');
    console.log(field1.getText(), field2.getText());

  }

  return (
    <div>
      <h1>PDF</h1>
    </div>
  );
};

export default Pdf;
